import { render, staticRenderFns } from "./ContentTop5.vue?vue&type=template&id=0cfc1cb6&scoped=true&"
import script from "./ContentTop5.vue?vue&type=script&lang=js&"
export * from "./ContentTop5.vue?vue&type=script&lang=js&"
import style0 from "./ContentTop5.vue?vue&type=style&index=0&id=0cfc1cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc1cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VList,VListItem,VListItemTitle,VProgressCircular})
